// Contenedor de pantalla: no desborda el área del Outlet (minWidth 0 ayuda con flex/tablas)
export const cajaPrincipalStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  minHeight: '100vh',
};